import { useEffect } from 'react';
import { motion } from 'framer-motion';
import visaAssistance from '../assets/visa-assistance.avif';
import airTicketing from '../assets/alexey-starki-91ykdj2WQeg-unsplash.jpg';
import hotelBooking from '../assets/bilderboken-rlwE8f8anOc-unsplash.jpg';
import tourPackages from '../assets/doug-greenman-E4qmFIfZbs0-unsplash.jpg';
import airportTransfer from '../assets/airport-transport.webp';
import travelInsurance from '../assets/alessandro-campi-QbDp1-RFNSw-unsplash.jpg';

export default function Services(){
  const services = [
    { title: 'Visa Assistance', desc: 'End‑to‑end visa guidance, documentation, and appointment support.', icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M4 7h16M4 12h16M7 17h10" stroke="currentColor" strokeWidth="1.6"/></svg>
    ), img: visaAssistance },
    { title: 'Air Ticketing', desc: 'Best fares, flexible options, and multi‑city itineraries.', icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M2 16l20-6-9 9-1-5-5-1 9-9" stroke="currentColor" strokeWidth="1.6"/></svg>
    ), img: airTicketing },
    { title: 'Hotel Booking', desc: 'Curated stays from budget to luxury with transparent pricing.', icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 21V8l9-5 9 5v13M7 21v-6h10v6" stroke="currentColor" strokeWidth="1.6"/></svg>
    ), img: hotelBooking },
    { title: 'Tour Packages', desc: 'Tailor‑made itineraries and guided experiences worldwide.', icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M4 6h16v12H4zM9 6v12M15 6v12" stroke="currentColor" strokeWidth="1.6"/></svg>
    ), img: tourPackages },
    { title: 'Airport Transfer', desc: 'Reliable pickup and drop with trusted local partners.', icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 17h18M5 17l2-6h10l2 6M7 17v3M17 17v3" stroke="currentColor" strokeWidth="1.6"/></svg>
    ), img: airportTransfer },
    { title: 'Travel Insurance', desc: 'Comprehensive coverage for health, baggage, and cancellations.', icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 3l7 3v6c0 4.418-3.582 8-7 8s-7-3.582-7-8V6l7-3Z" stroke="currentColor" strokeWidth="1.6"/></svg>
    ), img: travelInsurance },
  ];
  const container = { hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.08, delayChildren: 0.1 } } };
  const item = { hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } } };
  useEffect(() => {
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);
  return (
    <section className="container py-16">
      <motion.div variants={item} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }} className="max-w-2xl">
        <h1 className="text-4xl md:text-5xl font-bold">Services</h1>
        <p className="text-gray-600 mt-2">End‑to‑end travel solutions for a seamless experience—from paperwork to pickup.</p>
      </motion.div>

      <motion.ul variants={container} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
        {services.map((s)=> (
          <motion.li key={s.title} variants={item} whileHover={{ scale: 1.02 }} className="relative overflow-hidden rounded-2xl shadow-sm border border-gray-100 h-56 md:h-64 group">
            <img src={s.img} alt={s.title} className="absolute inset-0 w-full h-full object-cover"/>
            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/45 transition"/>
            <div className="absolute inset-0 p-6 flex flex-col justify-end text-white">
              <div className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-white/20 backdrop-blur text-white">
                {s.icon}
              </div>
              <div className="mt-3 text-2xl font-semibold">{s.title}</div>
              <p className="text-sm text-white/85 mt-1">{s.desc}</p>
            </div>
          </motion.li>
        ))}
      </motion.ul>
    </section>
  );
}

